var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exchange-detail padding-nav" },
    [
      _c(
        "el-button",
        {
          staticStyle: { "margin-bottom": "0.16rem" },
          attrs: { type: "text", icon: "el-icon-d-arrow-left" },
          on: { click: _vm.goback },
        },
        [_vm._v("Go\n    back")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "detail-title-1" }, [_vm._v("Borrow details")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "common-card" },
        [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "align-items": "baseline",
                "justify-content": "space-between",
              },
            },
            [
              _c("div", { staticClass: "detail-title-2" }, [
                _vm._v(
                  "\n        Borrow No. " +
                    _vm._s(
                      _vm.pageData.current && _vm.pageData.current.loanId
                    ) +
                    "\n        "
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticStyle: {
                      "margin-left": "0.40rem",
                      "margin-right": "0.32rem",
                    },
                  },
                  [
                    _vm.pageData.current && _vm.pageData.current.status == 2
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#FF9800",
                              "font-size": "0.18rem",
                            },
                          },
                          [
                            _c("i", {
                              staticClass:
                                "iconfont trn-yujing status-icon is-yujing",
                              staticStyle: {
                                "font-size": "0.24rem",
                                "margin-right": "0.1rem",
                              },
                              attrs: {
                                "el-tooltip": "",
                                effect: "dark",
                                content:
                                  "The collateral Value is below the Low Collatoral Warning Threshold and needs to be replenished.",
                                placement: "top",
                              },
                            }),
                            _vm._v("\n            Warned\n          "),
                          ]
                        )
                      : _vm.pageData.current && _vm.pageData.current.status == 3
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              color: "#D71817",
                              "font-size": "0.18rem",
                            },
                          },
                          [
                            _c("i", {
                              staticClass:
                                "iconfont trn-qingsuan status-icon is-qingsuan",
                              staticStyle: {
                                "font-size": "0.24rem",
                                "margin-right": "0.1rem",
                              },
                              attrs: {
                                "el-tooltip": "",
                                effect: "dark",
                                content:
                                  "The collateral value is below the Liquidation Threshold and has been liquidated.",
                                placement: "top",
                              },
                            }),
                            _vm._v("\n            Liquidated\n          "),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticStyle: { display: "flex", "align-items": "end" } },
                  [
                    _c("img", {
                      staticStyle: { width: "0.24rem" },
                      attrs: {
                        src: _vm.getRepaymentStatusImg(_vm.pageData),
                        alt: "",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "margin-left": "0.1rem",
                          "font-size": "0.20rem",
                        },
                      },
                      [_vm._v(_vm._s(_vm.getRepaymentStatusText(_vm.pageData)))]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticStyle: {
                    color: "#225BFC",
                    "font-weight": "500",
                    "font-size": "0.16rem",
                    cursor: "pointer",
                    "margin-left": "0.2rem",
                    display: "flex",
                    "align-items": "center",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.toExploder()
                    },
                  },
                },
                [
                  _vm._v("Details\n        "),
                  _c("img", {
                    staticStyle: {
                      width: "0.16rem",
                      height: "0.16rem",
                      "margin-left": "0.04rem",
                    },
                    attrs: {
                      src: require("@/assets/image/profile/blue_right_arrow.png"),
                    },
                  }),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { xs: 24, sm: 24, md: 8, lg: 8 } }, [
                _c("div", { staticClass: "detail-item spaceLeft" }, [
                  _c("span", { staticClass: "detail-item-label" }, [
                    _vm._v("Borrow Date(UTC):"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "#fff",
                        "font-weight": "500",
                        "font-size": "0.2rem",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.moment
                            .utc(
                              _vm.pageData.original &&
                                _vm.pageData.original.startTime * 1000
                            )
                            .format("YYYY-MM-DD HH:mm:ss")
                        )
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { xs: 24, sm: 24, md: 8, lg: 8 } }, [
                _c("div", { staticClass: "detail-item spaceLeft" }, [
                  _c("span", { staticClass: "detail-item-label" }, [
                    _vm._v("Due Date(UTC):"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "#fff",
                        "font-weight": "500",
                        "font-size": "0.2rem",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.calculateDueDate(
                            _vm.pageData.original &&
                              _vm.pageData.original.startTime
                          )
                        )
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { xs: 24, sm: 24, md: 8, lg: 8 } }, [
                _c("div", { staticClass: "detail-item spaceLeft" }, [
                  _c("span", { staticClass: "detail-item-label" }, [
                    _vm._v("Interest Rate:"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "#fff",
                        "font-weight": "500",
                        "font-size": "0.2rem",
                      },
                    },
                    [_vm._v(_vm._s(_vm.InterestRate))]
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "second-card" }, [
        _c(
          "div",
          { staticClass: "common-card", staticStyle: { flex: "0.9" } },
          [
            _c("div", { staticClass: "detail-title-2" }, [
              _vm._v("Initial Data"),
            ]),
            _vm._v(" "),
            _c(
              "el-row",
              [
                _c("el-col", { attrs: { xs: 24, sm: 24, md: 12, lg: 12 } }, [
                  _c(
                    "div",
                    { staticClass: "detail-item spaceLeft" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "detail-item-label",
                          staticStyle: { "font-size": "0.20rem" },
                        },
                        [_vm._v("Collateral:")]
                      ),
                      _vm._v(" "),
                      _c("big-number", {
                        staticStyle: {
                          color: "#fff",
                          "font-weight": "500",
                          "font-size": "0.28rem",
                        },
                        attrs: {
                          number:
                            _vm.pageData.original &&
                            _vm.pageData.original.unitAmount,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "unit",
                          staticStyle: { "margin-bottom": "-0.05rem" },
                        },
                        [_vm._v("UNIT")]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { xs: 24, sm: 24, md: 12, lg: 12 } }, [
                  _c(
                    "div",
                    { staticClass: "detail-item spaceLeft" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "detail-item-label",
                          staticStyle: { "font-size": "0.20rem" },
                        },
                        [_vm._v("Borrow:")]
                      ),
                      _vm._v(" "),
                      _c("big-number", {
                        staticStyle: {
                          color: "#fff",
                          "font-weight": "500",
                          "font-size": "0.28rem",
                        },
                        attrs: {
                          number:
                            _vm.pageData.original &&
                            _vm.pageData.original.loanAmount -
                              _vm.pageData.original.interest,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "unit",
                          staticStyle: { "margin-bottom": "-0.05rem" },
                        },
                        [_vm._v("TCash")]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { xs: 24, sm: 24, md: 12, lg: 12 } }, [
                  _c("div", { staticClass: "detail-item spaceLeft" }, [
                    _c("span", { staticClass: "detail-item-label" }, [
                      _vm._v(
                        "UNIT Price: $ " +
                          _vm._s(
                            _vm.pageData.original &&
                              _vm.pageData.original.unitPrice
                              ? (
                                  +_vm.pageData.original.unitPrice / 1e18
                                ).toFixed(2)
                              : "0.00"
                          )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "unit",
                        staticStyle: { "margin-bottom": "-0.05rem" },
                      },
                      [
                        _vm._v(
                          "Value: $ " +
                            _vm._s(
                              _vm.pageData.original &&
                                _vm.pageData.original.unitAmount &&
                                _vm.pageData.original.unitPrice
                                ? (
                                    ((+_vm.pageData.original.unitAmount /
                                      1e18) *
                                      +_vm.pageData.original.unitPrice) /
                                    1e18
                                  ).toFixed(2)
                                : "0.00"
                            )
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { xs: 24, sm: 24, md: 12, lg: 12 } }, [
                  _c(
                    "div",
                    {
                      staticClass: "detail-item spaceLeft",
                      staticStyle: { "align-items": "baseline" },
                    },
                    [
                      _c("span", { staticClass: "detail-item-label" }, [
                        _vm._v(
                          "TCash Price: $ " +
                            _vm._s(
                              _vm.pageData.original &&
                                _vm.pageData.original.loanPrice
                                ? (
                                    +_vm.pageData.original.loanPrice / 1e18
                                  ).toFixed(2)
                                : "0.00"
                            )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "unit",
                          staticStyle: { "margin-bottom": "-0.05rem" },
                        },
                        [
                          _vm._v(
                            "Value: $ " +
                              _vm._s(
                                _vm.pageData.original &&
                                  _vm.pageData.original.loanAmount &&
                                  _vm.pageData.original.loanPrice
                                  ? (
                                      ((+_vm.pageData.original.loanAmount /
                                        1e18) *
                                        +_vm.pageData.original.loanPrice) /
                                      1e18
                                    ).toFixed(2)
                                  : "0.00"
                              )
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { xs: 24, sm: 24, md: 12, lg: 12 } }, [
                  _c("div", { staticClass: "detail-item spaceLeft" }, [
                    _c("span", { staticClass: "detail-item-label" }, [
                      _vm._v("Risk Factors:"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#929DAD",
                          "font-weight": "500",
                          "font-size": "0.16rem",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            isNaN(
                              +_vm.pageData.original &&
                                _vm.pageData.original.CRF / 10000
                            )
                              ? "0.00"
                              : (
                                  +_vm.pageData.original &&
                                  _vm.pageData.original.CRF / 10000
                                ).toFixed(2)
                          )
                        ),
                      ]
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "common-card",
            staticStyle: {
              flex: "1.2",
              background:
                "linear-gradient( 307deg, rgba(0, 37, 104, 0.6) 0%, rgba(6, 33, 79, 0.6) 100%)",
            },
          },
          [
            _c("div", { staticClass: "detail-title-2" }, [
              _vm._v("Current Data"),
            ]),
            _vm._v(" "),
            _c(
              "el-row",
              [
                _c("el-col", { attrs: { xs: 24, sm: 24, md: 12, lg: 12 } }, [
                  _c(
                    "div",
                    { staticClass: "detail-item spaceLeft" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "detail-item-label",
                          staticStyle: { "font-size": "0.20rem" },
                        },
                        [_vm._v("Collateral:")]
                      ),
                      _vm._v(" "),
                      _c("big-number", {
                        staticStyle: {
                          color: "#fff",
                          "font-weight": "500",
                          "font-size": "0.28rem",
                        },
                        attrs: {
                          number:
                            _vm.pageData.current &&
                            _vm.pageData.current.unitAmount,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "unit",
                          staticStyle: { "margin-bottom": "-0.05rem" },
                        },
                        [_vm._v("UNIT")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "unit",
                          staticStyle: {
                            "font-size": "0.20rem",
                            "margin-bottom": "-0.05rem",
                            color: "#DCE0E7",
                          },
                        },
                        [
                          _vm._v("\n              $\n              "),
                          _c("big-number", {
                            staticStyle: {
                              "font-size": "0.28rem",
                              color: "#DCE0E7",
                            },
                            attrs: { number: _vm.unitValueInWei },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { xs: 24, sm: 24, md: 12, lg: 12 } }, [
                  _c(
                    "div",
                    { staticClass: "detail-item spaceLeft" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "detail-item-label",
                          staticStyle: { "font-size": "0.20rem" },
                        },
                        [_vm._v("Outstanding:")]
                      ),
                      _vm._v(" "),
                      _c("big-number", {
                        staticStyle: {
                          color: "#fff",
                          "font-weight": "500",
                          "font-size": "0.28rem",
                        },
                        attrs: {
                          number:
                            _vm.pageData.current &&
                            _vm.pageData.current.loanAmount,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "unit",
                          staticStyle: { "margin-bottom": "-0.05rem" },
                        },
                        [_vm._v("TCash")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "unit",
                          staticStyle: {
                            "margin-bottom": "-0.05rem",
                            "font-size": "0.20rem",
                            color: "#DCE0E7",
                          },
                        },
                        [
                          _vm._v("\n              $\n              "),
                          _c("big-number", {
                            staticStyle: {
                              "font-size": "0.28rem",
                              color: "#DCE0E7",
                            },
                            attrs: { number: _vm.calculateTCashValueInWei() },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              [
                _c("el-col", { attrs: { xs: 24, sm: 24, md: 12, lg: 12 } }, [
                  _c("div", { staticClass: "detail-item spaceLeft" }, [
                    _c("span", { staticClass: "detail-item-label" }, [
                      _vm._v("Risk Factors:"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#929DAD",
                          "font-weight": "500",
                          "font-size": "0.16rem",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            isNaN(
                              +_vm.pageData.current &&
                                _vm.pageData.current.CRF / 10000
                            )
                              ? "0.00"
                              : (
                                  +_vm.pageData.current &&
                                  _vm.pageData.current.CRF / 10000
                                ).toFixed(2)
                          )
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { xs: 24, sm: 24, md: 12, lg: 12 } }, [
                  _c(
                    "div",
                    { staticClass: "detail-item spaceLeft" },
                    [
                      _c("span", { staticClass: "detail-item-label" }, [
                        _vm._v("Borrow:"),
                      ]),
                      _vm._v(" "),
                      _c("big-number", {
                        staticStyle: {
                          color: "#fff",
                          "font-weight": "500",
                          "font-size": "0.2rem",
                        },
                        attrs: {
                          number:
                            _vm.pageData.current &&
                            _vm.pageData.current.loanAmount -
                              _vm.pageData.current.interest,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "unit",
                          staticStyle: { "margin-bottom": "-0.05rem" },
                        },
                        [_vm._v("TCash")]
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "space-between",
                  "align-items": "baseline",
                },
              },
              [
                _c("el-col", { attrs: { xs: 24, sm: 24, md: 12, lg: 12 } }, [
                  _c(
                    "div",
                    { staticClass: "detail-item spaceLeft" },
                    [
                      _c("span", { staticClass: "detail-item-label" }, [
                        _vm._v("Collateral Ratio:"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-weight": "500",
                            "font-size": "0.16rem",
                          },
                          style:
                            _vm.pageData.current &&
                            _vm.pageData.current.status == 3
                              ? "color: #D71718;"
                              : _vm.pageData.current &&
                                _vm.pageData.current.status == 2
                              ? "color: #FF8A1B;"
                              : "color: #36E3C2;",
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.calculateCollateralRatio()) +
                              "%\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.calculateCollateralRatio() > 0
                        ? _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content:
                                  _vm.pageData.current &&
                                  _vm.pageData.current.status == 3
                                    ? "Your collateral ratio has fallen below the liquidation threshold (50%) and has been liquidated."
                                    : "Your collateral ratio has fallen below the early warning threshold (75%). Please add collateral promptly.",
                                placement: "top",
                              },
                            },
                            [
                              _c("img", {
                                staticStyle: {
                                  "margin-left": "0.04rem",
                                  width: "0.16rem",
                                  height: "0.16rem",
                                  "margin-right": "0.08rem",
                                },
                                attrs: {
                                  src: require("@/assets/icons/more.png"),
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.pageData.current && _vm.pageData.current.status == 2
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#225BFC",
                                "font-size": "0.16rem",
                                "margin-left": "Add Collateral 0.08rem",
                                cursor: "pointer",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toAddCollate()
                                },
                              },
                            },
                            [_vm._v("Add Collateral")]
                          )
                        : _vm.pageData.current &&
                          _vm.pageData.current.status == 3
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "baseline",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#D71718",
                                    "font-size": "0.16rem",
                                  },
                                },
                                [
                                  _vm._v(
                                    "This borrow has been liquidated\n              "
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { xs: 24, sm: 24, md: 12, lg: 12 } }, [
                  _c(
                    "div",
                    { staticClass: "detail-item spaceLeft" },
                    [
                      _c("span", { staticClass: "detail-item-label" }, [
                        _vm._v("Interest:"),
                      ]),
                      _vm._v(" "),
                      _c("big-number", {
                        staticStyle: {
                          color: "#fff",
                          "font-weight": "500",
                          "font-size": "0.2rem",
                        },
                        attrs: {
                          number:
                            _vm.pageData.current &&
                            _vm.pageData.current.interest,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "unit",
                          staticStyle: { "margin-bottom": "-0.05rem" },
                        },
                        [_vm._v("TCash")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "#225BFC",
                            "font-weight": "500",
                            "font-size": "0.2rem",
                            "margin-bottom": "-0.05rem",
                            cursor: "pointer",
                            "margin-left": "0.2rem",
                            display: "flex",
                            "align-items": "center",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.goInterestRecord()
                            },
                          },
                        },
                        [
                          _vm._v("Details\n              "),
                          _c("img", {
                            staticStyle: {
                              width: "0.16rem",
                              height: "0.16rem",
                              "margin-left": "0.04rem",
                            },
                            attrs: {
                              src: require("@/assets/image/profile/blue_right_arrow.png"),
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "common-card" },
        [
          _c("div", { staticClass: "detail-title-2" }, [
            _vm._v("Collateral Change Record"),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "common-table",
              attrs: { data: _vm.tableList1 },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "date", label: "Time", align: "left" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.moment
                                .utc(row.date)
                                .format("YYYY.MM.DD HH:mm:ss")
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "event", label: "Type", align: "left" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              row.event === 0
                                ? "Borrow TCash"
                                : row.event === 1
                                ? "Return UNIT"
                                : "Add Collateral"
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "change",
                  label: "Balance change",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("big-number", { attrs: { number: row.change } }),
                        _vm._v(" "),
                        _c("span", { staticClass: "td-word-sm" }, [
                          _vm._v("UNIT"),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "amount",
                  label: "Total collateral",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("big-number", { attrs: { number: row.amount } }),
                        _vm._v(" "),
                        _c("span", { staticClass: "td-word-sm" }, [
                          _vm._v("UNIT"),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "price",
                  label: "UNlT spot price",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v("\n          $ "),
                        _c("big-number", { attrs: { number: row.price } }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Total Value", align: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v("\n          $ "),
                        _c("big-number", {
                          attrs: { number: (row.price / 1e18) * row.amount },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Starting collateral rate", align: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          "\n          " + _vm._s(row.LTV[0]) + "%\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "New collateral rate", align: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          "\n          " + _vm._s(row.LTV[1]) + "%\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            attrs: {
              total: _vm.queryParams1.total,
              page: _vm.queryParams1.page,
              limit: _vm.queryParams1.pageSize,
            },
            on: {
              "update:total": function ($event) {
                return _vm.$set(_vm.queryParams1, "total", $event)
              },
              "update:page": function ($event) {
                return _vm.$set(_vm.queryParams1, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.queryParams1, "pageSize", $event)
              },
              pagination: function ($event) {
                return _vm.getCollateralChangeRecord()
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "common-card" },
        [
          _c("div", { staticClass: "detail-title-2" }, [
            _vm._v("Repayment Record"),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "common-table",
              attrs: { data: _vm.tableList2 },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "timestamp", label: "Time", align: "left" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.moment
                                .utc(row.timestamp * 1000)
                                .format("YYYY.MM.DD HH:mm:ss")
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "type", label: "Type", align: "left" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v("\n          Repayment\n        ")]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "repayAmount",
                  label: "Repayment",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("big-number", {
                          attrs: { number: row.repayAmount },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "td-word-sm" }, [
                          _vm._v("TCash"),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "unitAmount",
                  label: "Collateral Released",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("big-number", { attrs: { number: row.unitAmount } }),
                        _vm._v(" "),
                        _c("span", { staticClass: "td-word-sm" }, [
                          _vm._v("UNIT"),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            attrs: {
              total: _vm.queryParams2.total,
              page: _vm.queryParams2.page,
              limit: _vm.queryParams2.pageSize,
            },
            on: {
              "update:total": function ($event) {
                return _vm.$set(_vm.queryParams2, "total", $event)
              },
              "update:page": function ($event) {
                return _vm.$set(_vm.queryParams2, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.queryParams2, "pageSize", $event)
              },
              pagination: function ($event) {
                return _vm.getRepaymentRecord()
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "interest-dialog",
          attrs: {
            title: "Interest Record",
            visible: _vm.interestDialogVisible,
            width: "50%",
            "before-close": function () {
              return (_vm.interestDialogVisible = false)
            },
            center: true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.interestDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "common-table",
              attrs: { data: _vm.interestTableList },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "date", label: "Time（UTC）", align: "left" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", { staticStyle: { color: "#6B6B6B" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.moment
                                .utc(row.createdAt)
                                .format("YYYY.MM.DD HH:mm:ss")
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "interest",
                  label: "Interest Amount",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "span",
                          { staticStyle: { color: "#6B6B6B" } },
                          [
                            _c("big-number", {
                              staticStyle: { color: "#6B6B6B" },
                              attrs: { number: row.interest },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "td-word-sm" }, [
                              _vm._v("TCash"),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            attrs: {
              total: _vm.interestQueryParams.total,
              page: _vm.interestQueryParams.page,
              limit: _vm.interestQueryParams.pageSize,
            },
            on: {
              "update:total": function ($event) {
                return _vm.$set(_vm.interestQueryParams, "total", $event)
              },
              "update:page": function ($event) {
                return _vm.$set(_vm.interestQueryParams, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.interestQueryParams, "pageSize", $event)
              },
              pagination: function ($event) {
                return _vm.getInterestRecord()
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("addCollate", { ref: "addCollate", on: { refresh: _vm.refresh } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }